<template>
	<div class="averagePayment">
		<div class="recipientAvgPayment">
			<el-progress :text-inside="true" :stroke-width="26" :percentage="percentage" :color="determinedColor"></el-progress>
		</div>
		<div class="text-color--gray fs-13">
			<div class="p-5">
				{{ $t("RecipientDetail.payment_action_text") }}
			</div>
			<div>
				{{ $t("RecipientDetail.avg_payment_unavailable_text") }}
			</div>
		</div>
	</div>
</template>
<script>
export default {
	data() {
		return {
			percentage: 80
		};
	},
	computed: {
		determinedColor() {
			if (this.percentage <= 20) {
				return '#3DE600';
			} else if (this.percentage <= 40) {
				return '#CFEB00';
			} else if (this.percentage <= 60) {
				return '#FFA800';
			} else if (this.percentage <= 80) {
				return '#F05B00';
			} else if (this.percentage <= 90) {
				return '#FF252B';
			} else {
				return {};
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.averagePayment {
	display: flex;
	flex-direction: column;

	.recipientAvgPayment {
		display: flex;
		justify-content: space-around;
		height: 41px;
	}

	>>>.el-progress-bar__innerText {
		color: transparent;
	}

	>>>.el-progress {
		width: 250px;
	}
}

</style>
